import { h } from "preact";
import useFormStore from "../../store/useFormStore";

import { formatCurrency } from "./cartHelpers";

export default function CartServiceRequirementsMessage() {
  const currentFranchise = useFormStore((state) => state.currentFranchise);
  const usesPricing = currentFranchise?.uses_pricing !== false;
  const cart = useFormStore((state) => state.cart);

  // Don't show message if minimum met or pricing not used
  if (cart.minimumAmountMet || !usesPricing) return null;

  return (
    <div className="bg-white p-6 shadow-sm border-3 border-coit-red text-">
      <span className="service-msg">
        Your order total of <strong>{formatCurrency(cart.minimumAmount - cart.minimumAmountNeeded)}</strong> does not meet our required <strong>{formatCurrency(cart.minimumAmount)}</strong> job minimum for the services performed. Service charge and tax are not included in the minimum charge total. You may add services to the order, or continue and be charged the minimum job amount.
      </span>
    </div>
  );
}
